import {AddToCartService} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/AddToCartService';
import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {
  findProductItemBySelectionIds,
  isPreOrder,
} from '@wix/wixstores-client-core/dist/es/src/productOptions/productUtils';
import {IProduct} from '../../types/galleryTypes';
import {
  hasNoVisibleVariants,
  isSelectedCombinationHidden,
  isSelectedCombinationOutOfStock,
  VariantInfo,
} from '../productHiddenVariants';

export const resolveProductManifestState = ({
  addToCartService,
  product,
  variantInfo,
  showHiddenVariants,
  isCatalogV3,
  price,
  inStock,
  isPreOrderState,
}: {
  addToCartService: AddToCartService;
  product: IProduct;
  variantInfo?: VariantInfo;
  showHiddenVariants: boolean;
  isCatalogV3: boolean;
  price: number;
  inStock: boolean;
  isPreOrderState: boolean;
}): {addToCartState: AddToCartState; isSelectedCombinationUnavailable: boolean} => {
  const isSelectedCombinationUnavailable = showHiddenVariants && isSelectedCombinationHidden(product, variantInfo);
  const isSelectedCombinationSoldOut = showHiddenVariants && isSelectedCombinationOutOfStock(product, variantInfo);

  const selectedVariant =
    product.productItems?.length && variantInfo?.variantSelectionIds?.length
      ? findProductItemBySelectionIds({product, selectionIds: variantInfo.variantSelectionIds})
      : undefined;

  return {
    isSelectedCombinationUnavailable,
    addToCartState: addToCartService.getButtonState({
      price,
      inStock: isSelectedCombinationSoldOut ? false : inStock,
      isPreOrderState: selectedVariant ? isPreOrder(product, selectedVariant) : isPreOrderState,
      isUnavailable: showHiddenVariants && hasNoVisibleVariants({product, isCatalogV3}),
    }),
  };
};
